<template>
    <div class=" col-12 rapd-steps list-none">
        <ul class="p-1 d-flex justify-content-sm-center flex-wrap flex-md-nowrap gap-5">
            <li class="text-center d-flex align-items-center">
                <i class="icon-rapd-list icon-empity"></i>
                <small>
                    {{ __('messages.reservation_card') }}
                </small>
            </li>
            <li class="text-center d-flex align-items-center">
                <i class="icon-rapd-list icon-shield"></i>
                <small>
                    {{ __('messages.price_and_availible') }}
                </small>
            </li>
            <li class="text-center d-flex align-items-center" v-if="siteConfig.code !== 'PTUSA' && siteConfig.code != 'PTES'">
                <i class="icon-rapd-list icon-happy"></i>
                <small>
                    {{ __('messages.payment_later_interes') }}
                </small>
            </li>
        </ul>
    </div>
</template>

<script>
const site = window.__pt.settings.site;

export default {
    data() {
        return {
            data: {},
            siteConfig: site
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
